import { AspectRatio, Box, Container, Heading, Input, Stack, Text } from '@chakra-ui/react'
import { motion, useAnimation } from 'framer-motion'
import { useState } from 'react'
import { getBase64, stringToHex } from '../utils/minorUtils'

type FileUploadProps = {
  setImageHex(val: string): any
}
//@ts-ignore
export default function FileUpload(props: FileUploadProps) {
  const controls = useAnimation()
  const startAnimation = () => controls.start('hover')
  const stopAnimation = () => controls.stop()
  const { setImageHex } = props
  const [fileDetails, setFileDetails] = useState({
    name: '',
    size: 0,
    format: '',
    b64: '',
    hexValue: '',
  })
  function fileChange(e: any) {
    getBase64(e.target.files[0])
      .then((result) => {
        setFileDetails({
          name: e.target.files[0].name.toString(),
          size: e.target.files[0].size / 1024,
          format: 'png',
          b64: result as string,
          hexValue: stringToHex(result as string),
        })
        setImageHex(stringToHex(result as string))
      })
      .catch((err) => {
        console.log(err)
      })
  }

  return (
    <Container my="4">
      <AspectRatio width="72" ratio={2}>
        <Box
          borderColor="gray.300"
          borderStyle="dashed"
          borderWidth="2px"
          rounded="md"
          shadow="sm"
          role="group"
          transition="all 150ms ease-in-out"
          _hover={{
            shadow: 'md',
          }}
          as={motion.div}
          initial="rest"
          animate="rest"
          whileHover="hover"
        >
          <Box position="relative" width="100%">
            <Stack p="4" textAlign="center" spacing="1">
              <Heading fontSize="lg" color="gray.700" fontWeight="bold">
                Drop image here (Max 95KB)
              </Heading>
              <Text fontWeight="light">or click to upload</Text>
            </Stack>

            <Input
              type="file"
              width="100%"
              height={'32'}
              position="absolute"
              top="0"
              left="0"
              opacity="0"
              aria-hidden="true"
              accept="image/*"
              onDragEnter={startAnimation}
              onDragLeave={stopAnimation}
              onChange={fileChange}
            />
          </Box>
        </Box>
      </AspectRatio>
      {fileDetails.name && (
        <Stack>
          <Text>File Name: {fileDetails.name}</Text>
          <Text>File Size: {fileDetails.size} KB</Text>
          
          {/* <Text>
            Data URL: {`${fileDetails.b64.slice(0, 35)}..........${fileDetails.b64.slice(-15)}`}
          </Text> */}
          {/* <Text>
            Hex Value:{' '}
            {`${fileDetails.hexValue.slice(0, 35)}..........${fileDetails.hexValue.slice(-15)}`}
          </Text> */}
        </Stack>
      )}
    </Container>
  )
}
